import { render, staticRenderFns } from "./InputDatetime.vue?vue&type=template&id=5fa5c18b&scoped=true&"
import script from "./InputDatetime.vue?vue&type=script&lang=js&"
export * from "./InputDatetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5c18b",
  null
  
)

export default component.exports